/* Quantity breaks for Buy Again on order lines — Ninja Patches version of ninjatransfers.com's assets/nt-qty-tiers.js
   (ported 2026-10-23; same window.NTQtyTiers API, so assets/nt-buy-again.js is unchanged in how it calls it).

   NP prices a custom patch line the way the product page and My Designs' reorder do (snippets/artwork-library-v2.liquid
   npPriceFor, C453i): the size-tier variant's price less the product's OWN volume tier for that quantity — the legacy
   .customTabelPlace__item rows on its product page (np-emb2's tiers() treats them as the truth), else #np-e2-config tiers.
   Patches have no cumulative discount: each line is its own (C453j), so nothing in the cart or other open lines counts.
   The cart charges it as an automatic discount ("50% off for 100+ patches"), percent off per piece.

   The product page is ~3 MB, with the rows ~0.8 MB in: the page is read as a stream and dropped as soon as the first
   ascending block of rows has ended. Read once per product, only for lines that have a minimum (custom patches); blanks,
   supplies and presses have no break table and keep the unit price.

     NTQtyTiers.price(o)  -> Promise({ each, off, cartQty, cartTotal, kind })   o = { unit, qty, handle, min }
     NTQtyTiers.offFor(rules, n) / eachPrice(unit, off) / groupKey(type) ('' = lines never count together) / reset() */
(function () {
  'use strict';
  if (window.NTQtyTiers) return;
  var cache = {};
  var ROW = /customTabelPlace__item[^"]*"[^>]*?min="(\d+)"[^>]*?off="(\d*)"/g;

  function rowsIn(html) {
    var out = [], m, last = -1, ended = false;
    ROW.lastIndex = 0;
    while ((m = ROW.exec(html)) !== null) {
      var mn = parseInt(m[1], 10), off = parseInt(m[2] || '0', 10) || 0;
      if (!(mn > 0)) continue;
      /* the page carries the table more than once: the first block ends when a min stops climbing */
      if (mn <= last) { ended = true; break; }
      last = mn;
      out.push({ min: mn, percent: off });
    }
    return { rows: out, ended: ended };
  }
  function configTiers(html) {
    try {
      var cm = /<script[^>]*id="np-e2-config"[^>]*>([\s\S]*?)<\/script>/.exec(html);
      var cfg = cm ? JSON.parse(cm[1]) : null;
      return (cfg && cfg.tiers || []).map(function (t) { return { min: +t.min || 0, percent: +t.off || 0 }; }).filter(function (t) { return t.min > 0; });
    } catch (e) { return []; }
  }
  function settle(html) {
    var r = rowsIn(html).rows;
    if (r.length < 2) { var c = configTiers(html); if (c.length >= 2) r = c; }
    return r.sort(function (a, b) { return a.min - b.min; });
  }
  function tiersFor(handle) {
    if (!handle) return Promise.resolve([]);
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle), { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) return [];
        if (!res.body || !res.body.getReader || typeof TextDecoder === 'undefined') return res.text().then(settle);
        var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
        return (function pump() {
          return reader.read().then(function (x) {
            if (x.done) return settle(buf);
            buf += dec.decode(x.value, { stream: true });
            var r = rowsIn(buf);
            if (r.ended && r.rows.length >= 2) { try { reader.cancel(); } catch (e) {} return settle(buf); }
            return pump();
          });
        })();
      }).catch(function () { return []; });
    }
    return cache[handle];
  }

  function offFor(rules, n) {
    var min = -1, off = 0;
    (rules || []).forEach(function (r) {
      var m = +r.min || 0, pc = +r.percent || 0;
      if (m > 0 && n >= m && m > min) { min = m; off = pc; }
    });
    return off;
  }
  /* the price each the cart charges at off%: its discount is per piece, rounded DOWN */
  function eachPrice(unit, off) { unit = Math.round(+unit || 0); return unit - Math.floor(unit * (+off || 0) / 100); }
  function price(o) {
    var unit = +o.unit || 0, qty = +o.qty || 0;
    if (!o.handle || !(+o.min > 1)) return Promise.resolve({ kind: 'none', each: unit, off: 0, cartQty: 0, cartTotal: 0 });
    return tiersFor(o.handle).then(function (rules) {
      if (!rules.length) return { kind: 'none', each: unit, off: 0, cartQty: 0, cartTotal: 0 };
      var off = offFor(rules, qty);
      return { kind: 'qty', each: eachPrice(unit, off), off: off, cartQty: 0, cartTotal: 0 };
    });
  }
  window.NTQtyTiers = {
    offFor: offFor, eachPrice: eachPrice, price: price, tiersFor: tiersFor,
    /* patch lines never count toward each other's break */
    groupKey: function () { return ''; },
    rulesFor: function () { return null; },
    reset: function () {}
  };
})();
